<div class="k-overlay" *ngIf="opened"></div>
<kendo-window [title]="ModalTitle" *ngIf="opened" (close)="close()" [@fadeInOnEnter]>
   <div>
      <div class="row m-2">
         <div class="col-md-6">
            <mdb-card class="w-100 p-2">
               <mdb-card-header class="k-hbox">
                  <div>
                     <h1 kendoCardTitle>Asset</h1>
                     <p kendoCardSubtitle>Filter by Fields</p>
                  </div>
               </mdb-card-header>
               <kendo-floatinglabel text="Make" class="w-100">
                  <input kendoTextBox [(ngModel)]="assetFilter.make" class="w-100" />
               </kendo-floatinglabel>
               <kendo-floatinglabel text="Model" class="w-100">
                  <input kendoTextBox [(ngModel)]="assetFilter.model" class="w-100" />
               </kendo-floatinglabel>
               <kendo-floatinglabel text="Description" class="w-100">
                  <input kendoTextBox [(ngModel)]="assetFilter.description" class="w-100" />
               </kendo-floatinglabel>
               <kendo-floatinglabel text="Component Type" class="w-100">
                  <kendo-dropdownlist
                     [(ngModel)]="assetFilter.componentTypeId"
                     class="w-100"
                     [data]="dataComponentTypes"
                     [filterable]="true"
                     [textField]="'description'"
                     [valueField]="'typeCode'"
                     [valuePrimitive]="true"
                     (filterChange)="handleFilterComponentType($event)"
                  >
                     <ng-template kendoDropDownListItemTemplate let-dataItem> {{ dataItem.description }} - {{ dataItem.typeCode }} </ng-template>
                  </kendo-dropdownlist>
               </kendo-floatinglabel>

               <kendo-floatinglabel text="Barcode" class="w-100">
                  <input kendoTextBox [(ngModel)]="assetFilter.assetBarCode" class="w-100" />
               </kendo-floatinglabel>

               <kendo-floatinglabel text="Functional Location 1" class="w-100">
                  <input kendoTextBox [(ngModel)]="assetFilter.functionalLocation1" class="w-100" />
               </kendo-floatinglabel>
               <kendo-floatinglabel text="Functional Location 2" class="w-100">
                  <input kendoTextBox [(ngModel)]="assetFilter.functionalLocation2" class="w-100" />
               </kendo-floatinglabel>
               <kendo-floatinglabel text="Functional Location 3" class="w-100">
                  <input kendoTextBox [(ngModel)]="assetFilter.functionalLocation3" class="w-100" />
               </kendo-floatinglabel>

            </mdb-card>
         </div>

         <div class="col-md-6">
            <mdb-card class="w-100 p-2">
               <mdb-card-header class="k-hbox">
                  <div>
                     <h1 kendoCardTitle>Dimension</h1>
                     <p kendoCardSubtitle>Filter by Dimensions</p>
                  </div>
               </mdb-card-header>
               <div *ngFor="let dimension of dimensions; let i = index">
                  <div>
                     <kendo-floatinglabel [text]="dimensions[i].dimensionDescription" class="w-100">
                        <kendo-combobox
                           [valuePrimitive]="true"
                           [data]="dimensions[i].dimensionDataList"
                           [textField]="'description'"
                           [valueField]="'id'"
                           [(ngModel)]="assetFilter.dimensionDataIdList[i]"
                           class="w-100"
                           [allowCustom]="true"
                        >
                        </kendo-combobox>
                     </kendo-floatinglabel>
                  </div>
               </div>
            </mdb-card>
         </div>
      </div>

      <mdb-card class="w-100 p-2">
         <div *ngIf="loading" class="d-flex justify-content-center">
            <mdb-spinner></mdb-spinner>
         </div>
         <kendo-grid [sortable]="true" [scrollable]="'none'" [resizable]="true" [rowClass]="rowCallback" [data]="gridData">
            <kendo-grid-column
               [columnMenu]="false"
               [filterable]="false"
               [groupable]="false"
               [reorderable]="true"
               [resizable]="false"
               [sortable]="false"
               [width]="120"
               field="photo"
               title="Photo"
               [headerClass]="'grid-header'"
            >
               <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  <div class="avatar mx-auto">
                     <img
                        style="height: 50px; width: 50px"
                        src="{{ dataItem.photo ? baseUrl + 'asset/photo/' + dataItem.assetCode + '/1' : '../assets/img/monitor_computer.jpg' }}"
                        class="img-fluid z-depth-2"
                        alt="avatar"
                     />
                  </div>
               </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="assetBarcode" title="Asset Barcode" filter="text" [headerClass]="'grid-header'"></kendo-grid-column>
            <kendo-grid-column field="description" title="Asset Description" filter="text" [headerClass]="'grid-header'"></kendo-grid-column>
            <kendo-grid-column field="componentType" title="Component Type" filter="text" [headerClass]="'grid-header'"></kendo-grid-column>
            <kendo-grid-column field="make" title="Make" filter="text" [headerClass]="'grid-header'"></kendo-grid-column>
            <kendo-grid-column field="model" title="Model" filter="text" [headerClass]="'grid-header'"></kendo-grid-column>
            <kendo-grid-column
               [columnMenu]="false"
               [filterable]="false"
               [groupable]="false"
               [reorderable]="false"
               [resizable]="false"
               [sortable]="false"
               [width]="60"
               field="assetCode"
               title=""
               [headerClass]="'grid-header'"
            >
               <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  <div class="d-flex" kendoTooltip tooltipClass="tooltip-ams">
                     <button
                        title="Select"
                        (click)="selectAsset(dataItem)"
                        kendoButton
                        [icon]="'check-circle'"
                        class="ml-1"
                     ></button>
                    
                  </div>
               </ng-template>
            </kendo-grid-column>
         </kendo-grid>
         <div class="modal-footer d-flex justify-content-center">
            <button *ngIf="!loading" kendoButton icon="filter" [primary]="true" type="button" (click)="filterAssets()">Search</button>
            <button *ngIf="!loading" kendoButton icon="clear" type="button" (click)="resetFilter()">Clear Filters</button>
         </div>
      </mdb-card>
   </div>
</kendo-window>
